import { useState } from "react";

import { PrimaryButton } from "@shared/buttons";

export const CopyButton = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: string;
}) => {
  const [showCopiedText, setShowCopiedText] = useState(false);

  return (
    <div className="flex gap-4 justify-start items-center">
      <PrimaryButton
        className="uppercase w-fit"
        onClick={() => {
          try {
            window.navigator.clipboard.writeText(value);
            setShowCopiedText(true);
            setTimeout(() => setShowCopiedText(false), 2000);
          } catch (err) {
            console.error(err);
          }
        }}
      >
        <div className="justify-center items-center gap-2 inline-flex uppercase">
          <i className="fa-regular fa-sharp fa-link" />
          {children}
        </div>
      </PrimaryButton>
      {showCopiedText && (
        <span className="text-interstellar-1">Copied to clipboard!</span>
      )}
    </div>
  );
};
